(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 699px)');
  const SLIDER_SELECTOR = '[data-mobile-product-slider]';

  function collectSliders(root = document) {
    const sliders = [];

    if (root instanceof Element && root.matches(SLIDER_SELECTOR)) {
      sliders.push(root);
    }

    if (root.querySelectorAll) {
      sliders.push(...root.querySelectorAll(SLIDER_SELECTOR));
    }

    return sliders;
  }

  function initialiseSlider(slider) {
    if (slider.dataset.mobileSliderReady === 'true') {
      return;
    }

    const viewport = slider.querySelector(
      '[data-mobile-slider-viewport]'
    );

    const track = slider.querySelector(
      '[data-mobile-slider-track]'
    );

    const slides = Array.from(
      slider.querySelectorAll('[data-mobile-slider-slide]')
    );

    const previousButton = slider.querySelector(
      '[data-mobile-slider-previous]'
    );

    const nextButton = slider.querySelector(
      '[data-mobile-slider-next]'
    );

    const currentElement = slider.querySelector(
      '[data-mobile-slider-current]'
    );

    if (!viewport || !track || slides.length < 2) {
      return;
    }

    slider.dataset.mobileSliderReady = 'true';

    let currentIndex = 0;

    let startX = 0;
    let startY = 0;
    let currentX = 0;

    let draggingHorizontally = false;
    let suppressNextClick = false;

    function clampIndex(index) {
      return Math.max(
        0,
        Math.min(index, slides.length - 1)
      );
    }

    function updateControls() {
      const isFirst = currentIndex === 0;
      const isLast = currentIndex === slides.length - 1;

      if (previousButton) {
        previousButton.disabled = isFirst;

        previousButton.setAttribute(
          'aria-disabled',
          String(isFirst)
        );
      }

      if (nextButton) {
        nextButton.disabled = isLast;

        nextButton.setAttribute(
          'aria-disabled',
          String(isLast)
        );
      }

      if (currentElement) {
        currentElement.textContent = String(
          currentIndex + 1
        );
      }
    }

    function moveToSlide(index, animate = true) {
      currentIndex = clampIndex(index);

      if (!animate) {
        track.classList.add('is-dragging');
      } else {
        track.classList.remove('is-dragging');
      }

      track.style.transform =
        `translate3d(-${currentIndex * 100}%, 0, 0)`;

      updateControls();

      if (!animate) {
        requestAnimationFrame(() => {
          track.classList.remove('is-dragging');
        });
      }
    }

    function stopButtonPointer(event) {
      event.stopPropagation();
    }

    if (previousButton) {
      previousButton.addEventListener(
        'pointerdown',
        stopButtonPointer
      );

      previousButton.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (!previousButton.disabled) {
            moveToSlide(currentIndex - 1);
          }
        },
        true
      );
    }

    if (nextButton) {
      nextButton.addEventListener(
        'pointerdown',
        stopButtonPointer
      );

      nextButton.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (!nextButton.disabled) {
            moveToSlide(currentIndex + 1);
          }
        },
        true
      );
    }

    viewport.addEventListener(
      'touchstart',
      (event) => {
        if (!MOBILE_QUERY.matches) {
          return;
        }

        const touch = event.touches[0];

        startX = touch.clientX;
        startY = touch.clientY;
        currentX = startX;

        draggingHorizontally = false;
        suppressNextClick = false;

        track.classList.add('is-dragging');
      },
      {
        passive: true
      }
    );

    viewport.addEventListener(
      'touchmove',
      (event) => {
        if (!MOBILE_QUERY.matches) {
          return;
        }

        const touch = event.touches[0];

        const differenceX =
          touch.clientX - startX;

        const differenceY =
          touch.clientY - startY;

        currentX = touch.clientX;

        /*
         * Ignore short movement and vertical scrolling.
         */
        if (
          Math.abs(differenceX) <= 8 ||
          Math.abs(differenceX) <=
            Math.abs(differenceY)
        ) {
          return;
        }

        draggingHorizontally = true;
        suppressNextClick = true;

        event.preventDefault();

        const viewportWidth =
          viewport.clientWidth || 1;

        let dragPercentage =
          (differenceX / viewportWidth) * 100;

        /*
         * Add resistance when dragging past the first image.
         */
        if (
          currentIndex === 0 &&
          differenceX > 0
        ) {
          dragPercentage *= 0.25;
        }

        /*
         * Add resistance when dragging past the final image.
         */
        if (
          currentIndex === slides.length - 1 &&
          differenceX < 0
        ) {
          dragPercentage *= 0.25;
        }

        const translatePercentage =
          -(currentIndex * 100) +
          dragPercentage;

        track.style.transform =
          `translate3d(${translatePercentage}%, 0, 0)`;
      },
      {
        passive: false
      }
    );

    viewport.addEventListener(
      'touchend',
      () => {
        if (!MOBILE_QUERY.matches) {
          return;
        }

        track.classList.remove('is-dragging');

        const differenceX =
          currentX - startX;

        const swipeThreshold = Math.min(
          50,
          Math.max(
            30,
            viewport.clientWidth * 0.16
          )
        );

        if (
          draggingHorizontally &&
          Math.abs(differenceX) >=
            swipeThreshold
        ) {
          if (differenceX < 0) {
            moveToSlide(currentIndex + 1);
          } else {
            moveToSlide(currentIndex - 1);
          }
        } else {
          /*
           * Return to the current complete slide.
           */
          moveToSlide(currentIndex);
        }

        draggingHorizontally = false;
      },
      {
        passive: true
      }
    );

    viewport.addEventListener(
      'touchcancel',
      () => {
        track.classList.remove('is-dragging');

        draggingHorizontally = false;

        moveToSlide(currentIndex);
      },
      {
        passive: true
      }
    );

    /*
     * Prevent a swipe from opening the product.
     * Normal taps continue opening the product page.
     */
    viewport.addEventListener(
      'click',
      (event) => {
        if (!suppressNextClick) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        suppressNextClick = false;
      },
      true
    );

    viewport.addEventListener(
      'dragstart',
      (event) => {
        event.preventDefault();
      }
    );

    /*
     * Keep the selected image aligned if the card width changes.
     */
    if ('ResizeObserver' in window) {
      const resizeObserver =
        new ResizeObserver(() => {
          moveToSlide(currentIndex, false);
        });

      resizeObserver.observe(viewport);
    }

    moveToSlide(0, false);
  }

  function initialiseAll(root = document) {
    /*
     * Do not initialize on tablet or desktop.
     */
    if (!MOBILE_QUERY.matches) {
      return;
    }

    collectSliders(root).forEach(
      initialiseSlider
    );
  }

  function handleMediaChange(event) {
    if (event.matches) {
      initialiseAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialiseAll()
    );
  } else {
    initialiseAll();
  }

  /*
   * Initialize when resizing from desktop to mobile.
   */
  if (
    typeof MOBILE_QUERY.addEventListener ===
    'function'
  ) {
    MOBILE_QUERY.addEventListener(
      'change',
      handleMediaChange
    );
  } else if (
    typeof MOBILE_QUERY.addListener ===
    'function'
  ) {
    MOBILE_QUERY.addListener(
      handleMediaChange
    );
  }

  /*
   * Prestige replaces product cards after collection filtering,
   * sorting and AJAX pagination.
   */
  const observer = new MutationObserver(
    (mutations) => {
      if (!MOBILE_QUERY.matches) {
        return;
      }

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(
          (node) => {
            if (node instanceof Element) {
              initialiseAll(node);
            }
          }
        );
      });
    }
  );

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  /*
   * Shopify theme editor support.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialiseAll(event.target);
    }
  );
})();